/* global Geocomplete, StatisticsPositions, Forms $ */
import { InitMainAddressCheckboxes } from 'lib/location_form'

function initGeocompleteFields () {
  $('#addresses .nested-fields').each(function () {
    Geocomplete.initSelect({
      input: $(this).find('#gmaps-input-address'),
      details: $(this).find('.details')
    })
  })
}

window['client_companies#show'] = function () {
  $(document).on('change', '.filter-process select#candidate_id, .filter-process select#event_type', function () {
    this.form.submit()
  })
}

window['client_companies#statistics'] = function () {
  Helpers.initCollapsableTable()
  StatisticsPositions.init()
}

window['client_companies#new'] = () => {
  initGeocompleteFields()
}

window['client_companies#edit'] = () => {
  initGeocompleteFields()
}

window['client_companies#edit_addresses'] = function () {
  initGeocompleteFields()
  InitMainAddressCheckboxes()

  $('#addresses').on('cocoon:after-insert', function (e, element) {
    Geocomplete.initSelect({
      input: element.find('#gmaps-input-address'),
      details: element.find('.details')
    })

    Forms.initCheckbox()
    InitMainAddressCheckboxes()
  })
}
